import clsx from 'clsx'
import { DetailedHTMLProps, FC, forwardRef, SelectHTMLAttributes } from 'react'
import { MdChevronRight } from 'react-icons/md'
import s from './Select.module.scss'
export type SelectProps = {
  className?: string
  noMargin?: boolean
} & DetailedHTMLProps<
  SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
>

const Select: FC<SelectProps> = forwardRef(
  ({ className, noMargin, children, ...props }, ref) => {
    return (
      <div className={clsx(s.wrapper, {
        [s.noMargin]: noMargin
      })}>
        <select className={clsx(s.root, className)} {...props} ref={ref}>
          {children}
        </select>
        <div className={s.arrow}>
          <MdChevronRight className={s.icon} />
        </div>
      </div>
    )
  }
)

Select.displayName = 'Select'
export default Select
